import { format } from 'date-fns-tz'

import { dayMinutesToHoursMinutes } from '../../../helpers/helpers'

const getSummaryText = (amenity, calendarValues, selectedTime, short = false, t) => {
  const { multiDayBooking, checkInTime, checkOutTime } = amenity
  let summaryText = multiDayBooking
    ? t(
        short
          ? 'reservations:getSummaryText.multiDayShort'
          : 'reservations:getSummaryText.multiDayFull',
        {
          startDate: format(calendarValues[0], 'MMMM dd, yyyy'),
          endDate: format(calendarValues[1], 'MMMM dd, yyyy'),
        },
      )
    : t(
        short
          ? 'reservations:getSummaryText.singleDayShort'
          : 'reservations:getSummaryText.singleDayFull',
        {
          date: format(calendarValues[0], 'EEEE, MMMM dd, yyyy'),
          startTime: dayMinutesToHoursMinutes(selectedTime.startTime),
          endTime: dayMinutesToHoursMinutes(
            (selectedTime.endTime || selectedTime.startTime) + amenity.timeInterval,
          ),
        },
      )
  if (multiDayBooking && typeof checkInTime === 'number') {
    if (typeof checkOutTime === 'number') {
      summaryText += t('reservations:getSummaryText.suffixCheckInCheckOut', {
        checkInTime: dayMinutesToHoursMinutes(checkInTime),
        checkOutTime: dayMinutesToHoursMinutes(checkOutTime),
      })
    } else {
      summaryText += t('reservations:getSummaryText.suffixCheckInOnly', {
        checkInTime: dayMinutesToHoursMinutes(checkInTime),
      })
    }
  }
  return summaryText
}

export default getSummaryText
